import { motion } from 'framer-motion';

const stats = [
  { value: '15–25%', label: 'Of cancellation attempts saved' },
  { value: '2 hour', label: 'Average response time' },
  { value: '100%', label: 'Handled by trained retention specialists' },
];

export default function Stats() {
  return (
    <section data-testid="stats-section" className="border-y border-[#0A1628]/10 bg-white/60">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-10 sm:gap-0 sm:divide-x divide-[#0A1628]/10">
          {stats.map((stat, i) => (
            <motion.div
              key={stat.label}
              data-testid={`stat-item-${i}`}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: i * 0.12, ease: [0.22, 1, 0.36, 1] }}
              className="flex flex-col items-center sm:items-center text-center px-8"
            >
              <span className="text-5xl lg:text-6xl font-black tracking-tighter text-[#0A1628] leading-none mb-2">
                {stat.value}
              </span>
              <span className="text-xs font-bold uppercase tracking-[0.18em] text-[#0A1628]/50">
                {stat.label}
              </span>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
